import { useState, useRef, useEffect } from 'react';
import './header.css';
import logo from '../../assets/company/cae-logo.png';
import { useLocation } from 'react-router-dom';

export default function Header() {
    const [showSubmenu, setShowSubmenu] = useState(false);
    const [showServicesSubmenu, setShowServicesSubmenu] = useState(false);

    const triggerRef = useRef(null);
    const servicesTriggerRef = useRef(null);
    const submenuRef = useRef(null);
    const servicesSubmenuRef = useRef(null);

    const [submenuStyle, setSubmenuStyle] = useState({});
    const [servicesSubmenuStyle, setServicesSubmenuStyle] = useState({});

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [showMobileSubmenu, setMobileShowSubmenu] = useState(false);
    const [showMobileServicesSubmenu, setShowMobileServicesSubmenu] = useState(false);

    const [mobileVersion, setMobileVersion] = useState(window.innerWidth <= 767);
    const mobileMenuRef = useRef(null);

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const toggleSubmenu = () => {
        setShowSubmenu(!showSubmenu);
        setShowServicesSubmenu(false);
    };

    const toggleServicesSubmenu = () => {
        setShowServicesSubmenu(!showServicesSubmenu);
        setShowSubmenu(false);
    };

    const toggleMobileSubMenu = () => {
        setMobileShowSubmenu(!showMobileSubmenu);
    };

    const toggleMobileServicesSubMenu = () => {
        setShowMobileServicesSubmenu(!showMobileServicesSubmenu);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            const clickedOutsideExecutive = submenuRef.current &&
                !submenuRef.current.contains(event.target) &&
                triggerRef.current &&
                !triggerRef.current.contains(event.target);

            const clickedOutsideServices = servicesSubmenuRef.current &&
                !servicesSubmenuRef.current.contains(event.target) &&
                servicesTriggerRef.current &&
                !servicesTriggerRef.current.contains(event.target);

            const clickedOutsideMobileMenu = mobileMenuRef.current &&
                !mobileMenuRef.current.contains(event.target) &&
                !triggerRef.current.contains(event.target) &&
                !servicesTriggerRef.current.contains(event.target);

            if (!isMobileMenuOpen && clickedOutsideExecutive) {
                setShowSubmenu(false);
            }

            if (!isMobileMenuOpen && clickedOutsideServices) {
                setShowServicesSubmenu(false);
            }

            if (isMobileMenuOpen && clickedOutsideMobileMenu) {
                setIsMobileMenuOpen(false);
                setMobileShowSubmenu(false);
                setShowMobileServicesSubmenu(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showSubmenu, showServicesSubmenu, isMobileMenuOpen]);

    useEffect(() => {
        if (showSubmenu && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            const navRect = triggerRef.current.closest('.nav-container').getBoundingClientRect();
            setSubmenuStyle({
                position: 'absolute',
                left: rect.left - navRect.left + 'px',
            });
        }

        if (showServicesSubmenu && servicesTriggerRef.current) {
            const rect = servicesTriggerRef.current.getBoundingClientRect();
            const navRect = servicesTriggerRef.current.closest('.nav-container').getBoundingClientRect();
            setServicesSubmenuStyle({
                position: 'absolute',
                left: rect.left - navRect.left + 'px',
            });
        }

        function handleResize() {
            setMobileVersion(window.innerWidth <= 767);
        }

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [showSubmenu, showServicesSubmenu]);

    return (
        <nav className="navbar">
            <div className={isMobileMenuOpen ? 'mobile-nav-container' : 'nav-container'}>
                <div className='nav-header'>
                    <div className="header-logo">
                        <a href="/">
                            <img src={logo} alt="Company Logo" />
                        </a>
                    </div>
                    <div className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`} onClick={toggleMobileMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    <ul className="nav-links">
                        <li><a href="/">HOME</a></li>
                        <li ref={triggerRef} onClick={toggleSubmenu}>
                            <a href="#">EXECUTIVE SEARCH</a>
                        </li>
                        <li ref={servicesTriggerRef} onClick={toggleServicesSubmenu}>
                            <a href="#">SERVICES</a>
                        </li>
                        <li><a href="/about">ABOUT US</a></li>
                        <li><a href="/contact">CONTACT US</a></li>
                    </ul>
                </div>

                {/* Mobile Menu */}
                {isMobileMenuOpen && (
                    <div className="mobile-menu" ref={mobileMenuRef}>
                        <a href="/">HOME</a>

                        <a className="mobile-submenu-trigger" onClick={toggleMobileSubMenu}>
                            EXECUTIVE SEARCH
                        </a>
                        {showMobileSubmenu && (
                            <ul className="submenu mobile-submenu">
                                <li><a href="/executivesearch#executive" onClick={() => setIsMobileMenuOpen(false)}>- ABOUT EXECUTIVE SEARCH</a></li>
                                <li><a href="/executivesearch#functions" onClick={() => setIsMobileMenuOpen(false)}>- OUR FUNCTIONS</a></li>
                                <li><a href="/executivesearch#customers" onClick={() => setIsMobileMenuOpen(false)}>- OUR CUSTOMERS</a></li>
                                <li><a href="/executivesearch#focus" onClick={() => setIsMobileMenuOpen(false)}>- COUNTRY AND INDUSTRY FOCUS</a></li>
                            </ul>
                        )}

                        <a className="mobile-submenu-trigger" onClick={toggleMobileServicesSubMenu}>
                            SERVICES
                        </a>
                        {showMobileServicesSubmenu && (
                            <ul className="submenu mobile-submenu">
                                <li><a href="/services#directsearch" onClick={() => setIsMobileMenuOpen(false)}>- DIRECT SEARCH</a></li>
                                <li><a href="/services#cloud" onClick={() => setIsMobileMenuOpen(false)}>- CLOUD CANDIDATE POOLS</a></li>
                                <li><a href="/services#knowledge" onClick={() => setIsMobileMenuOpen(false)}>- MARKET ANALYSIS</a></li>
                                <li><a href="/services#audit" onClick={() => setIsMobileMenuOpen(false)}>- PERFORMANCE AUDITS</a></li>
                                <li><a href="/services#market" onClick={() => setIsMobileMenuOpen(false)}>- MARKET ENTRIES</a></li>
                                <li><a href="/services#interim" onClick={() => setIsMobileMenuOpen(false)}>- INTERIM MANAGEMENT</a></li>
                            </ul>
                        )}

                        <a href="/about">ABOUT US</a>
                        <a href="/contact">CONTACT US</a>
                    </div>
                )}

                {/* Desktop EXECUTIVE SEARCH Submenu */}
                {showSubmenu && !isMobileMenuOpen && (
                    <ul ref={submenuRef} className="submenu outside-submenu" style={submenuStyle}>
                        <li><a href="/executivesearch#executive" onClick={() => setShowSubmenu(false)}>ABOUT EXECUTIVE SEARCH</a></li>
                        <li><a href="/executivesearch#functions" onClick={() => setShowSubmenu(false)}>OUR FUNCTIONS</a></li>
                        <li><a href="/executivesearch#customers" onClick={() => setShowSubmenu(false)}>OUR CUSTOMERS</a></li>
                        <li><a href="/executivesearch#focus" onClick={() => setShowSubmenu(false)}>COUNTRY AND INDUSTRY FOCUS</a></li>
                    </ul>
                )}

                {/* Desktop SERVICES Submenu */}
                {showServicesSubmenu && !isMobileMenuOpen && (
                    <ul ref={servicesSubmenuRef} className="submenu outside-submenu" style={servicesSubmenuStyle}>
                        <li><a href="/services#directsearch" onClick={() => setShowServicesSubmenu(false)}>DIRECT SEARCH</a></li>
                        <li><a href="/services#cloud" onClick={() => setShowServicesSubmenu(false)}>CLOUD CANDIDATE POOLS</a></li>
                        <li><a href="/services#knowledge" onClick={() => setShowServicesSubmenu(false)}>MARKET ANALYSIS</a></li>
                        <li><a href="/services#audit" onClick={() => setShowServicesSubmenu(false)}>PERFORMANCE AUDITS</a></li>
                        <li><a href="/services#market" onClick={() => setShowServicesSubmenu(false)}>MARKET ENTRIES</a></li>
                        <li><a href="/services#interim" onClick={() => setShowServicesSubmenu(false)}>INTERIM MANAGEMENT</a></li>
                    </ul>
                )}
            </div>
        </nav>
    );
}